import styled from '@emotion/styled';
import LightboxgallerySvg from '../../../../public/static/icons/lightboxgallery.svg';

export const StyledButtonWrapper = styled.div`
    position: absolute;
    width: 100%;
    left: 0;
    right: 0;
    top: 0;
`;
export const StyledLightboxGalleryIcon = styled(LightboxgallerySvg)`
    width: 12px;
    margin-left: -4px;
    margin-right: 10px;
    fill: currentColor;
`;
